import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { logout } from "../redux/actions/userActionCreators";
import { setOrganizationId } from "../redux/actions/organizationProfileCreators";

const AutomaticLogOutControl = () => {
  const history = useHistory();
  const storedUser = localStorage.getItem("user");
  const automaticLogout = useSelector((state) => state.user.automaticLogout);
  const publicId = JSON.parse(storedUser)?.public_id;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={automaticLogout}
        aria-labelledby="draggable-dialog-title"
        disableBackdropClick
        maxWidth="xl"
        PaperProps={{ sx: { width: isMobile ? "80%" : "50%", zIndex:99 } }}
      >
        <Box display="flex" alignItems="center" ml={3}>
          <WarningAmberIcon color="error" />
          <DialogTitle id="draggable-dialog-title">Alert!</DialogTitle>{" "}
        </Box>
        <DialogContent>
          <DialogContentText>{t("automatic_sign_out")}</DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: isMobile && "flex",
            flexDirection: isMobile && "column",
            gap: isMobile && 1,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              dispatch(setOrganizationId(null));
              dispatch(logout(publicId, history));
            }}
            size="small"
            sx={{ width: "100%", marginRight: "6px" }}
          >
            {t("logout")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AutomaticLogOutControl;
